import * as C from ".";
import { IEntry } from "../base";

export * from "./cart_button";
export * from "./card";
export * from "./call_to_action";
export * from "./conference";
export * from "./email";
export * from "./faq";
export * from "./login_button";
export * from "./form_field";
export * from "./migration_history";
export * from "./menu";
export * from "./menu_button";
export * from "./ministry";
export * from "./page_metadata";
export * from "./page";
export * from "./redirect";
export * from "./partner_church";
export * from "./resource_set";
export * from "./resource";
export * from "./resource_tree";
export * from "./section-block-text";
export * from "./section-card";
export * from "./section-code-widget";
export * from "./section-card-deck";
export * from "./section-domain-object-header";
export * from "./section-email-capture";
export * from "./section-contact-us";
export * from "./section-hero";
export * from "./section-featured-items";
export * from "./section-faq";
export * from "./section-image-gallery";
export * from "./section-intro";
export * from "./section-marquee-text";
export * from "./section-http-error";
export * from "./section-ministry-details";
export * from "./section-location-map";
export * from "./section-partner-churches";
export * from "./section-product-list";
export * from "./section-resource-landing";
export * from "./section-video-highlight";
export * from "./section-video";
export * from "./section-testimonials";
export * from "./testimonial";
export * from "./site-config";

export interface TypeDirectory {
  'cartButton': C.ICartButton;
  'card': C.ICard;
  'callToAction': C.ICalltoAction;
  'conference': C.IConference;
  'email': C.IEmail;
  'faq': C.IFaq;
  'loginButton': C.ILoginButton;
  'formField': C.IFormField;
  'migrationHistory': C.IMigrationHistory;
  'menu': C.IMenu;
  'menuButton': C.IMenuButton;
  'ministry': C.IMinistry;
  'pageMetadata': C.IPageMetadata;
  'page': C.IPage;
  'redirect': C.IRedirect;
  'partnerChurch': C.IPartnerChurch;
  'resourceSet': C.IResourceSet;
  'resource': C.IResource;
  'resourceTree': C.IResourceTree;
  'section-block-text': C.ISectionBlockText;
  'section-card': C.ISectionCard;
  'section-code-widget': C.ISectionCodeWidget;
  'section-card-deck': C.ISectionCardDeck;
  'section-domain-object-header': C.ISectionDomainObjectHeader;
  'section-email-capture': C.ISectionEmailCapture;
  'section-contact-us': C.ISectionContactUs;
  'section-hero': C.ISectionHero;
  'section-featured-items': C.ISectionFeaturedItems;
  'section-faq': C.ISectionFaq;
  'section-image-gallery': C.ISectionImageGallery;
  'section-intro': C.ISectionIntro;
  'section-marquee-text': C.ISectionMarqueeText;
  'section-http-error': C.ISectionHttpError;
  'section-ministry-details': C.ISectionMinistryDetails;
  'section-location-map': C.ISectionLocationMap;
  'section-partner-churches': C.ISectionPartnerChurches;
  'section-product-list': C.ISectionProductList;
  'section-resource-landing': C.ISectionResourceLanding;
  'section-video-highlight': C.ISectionVideoHighlight;
  'section-video': C.ISectionVideo;
  'section-testimonials': C.ISectionTestimonials;
  'testimonial': C.ITestimonial;
  'site-config': C.ISiteConfig;
}

export interface ClassDirectory {
  'cartButton': C.CartButton;
  'card': C.Card;
  'callToAction': C.CalltoAction;
  'conference': C.Conference;
  'email': C.Email;
  'faq': C.Faq;
  'loginButton': C.LoginButton;
  'formField': C.FormField;
  'migrationHistory': C.MigrationHistory;
  'menu': C.Menu;
  'menuButton': C.MenuButton;
  'ministry': C.Ministry;
  'pageMetadata': C.PageMetadata;
  'page': C.Page;
  'redirect': C.Redirect;
  'partnerChurch': C.PartnerChurch;
  'resourceSet': C.ResourceSet;
  'resource': C.Resource;
  'resourceTree': C.ResourceTree;
  'section-block-text': C.SectionBlockText;
  'section-card': C.SectionCard;
  'section-code-widget': C.SectionCodeWidget;
  'section-card-deck': C.SectionCardDeck;
  'section-domain-object-header': C.SectionDomainObjectHeader;
  'section-email-capture': C.SectionEmailCapture;
  'section-contact-us': C.SectionContactUs;
  'section-hero': C.SectionHero;
  'section-featured-items': C.SectionFeaturedItems;
  'section-faq': C.SectionFaq;
  'section-image-gallery': C.SectionImageGallery;
  'section-intro': C.SectionIntro;
  'section-marquee-text': C.SectionMarqueeText;
  'section-http-error': C.SectionHttpError;
  'section-ministry-details': C.SectionMinistryDetails;
  'section-location-map': C.SectionLocationMap;
  'section-partner-churches': C.SectionPartnerChurches;
  'section-product-list': C.SectionProductList;
  'section-resource-landing': C.SectionResourceLanding;
  'section-video-highlight': C.SectionVideoHighlight;
  'section-video': C.SectionVideo;
  'section-testimonials': C.SectionTestimonials;
  'testimonial': C.Testimonial;
  'site-config': C.SiteConfig;
}

export function wrap(entry: C.ICartButton): C.CartButton;
export function wrap(entry: C.ICard): C.Card;
export function wrap(entry: C.ICalltoAction): C.CalltoAction;
export function wrap(entry: C.IConference): C.Conference;
export function wrap(entry: C.IEmail): C.Email;
export function wrap(entry: C.IFaq): C.Faq;
export function wrap(entry: C.ILoginButton): C.LoginButton;
export function wrap(entry: C.IFormField): C.FormField;
export function wrap(entry: C.IMigrationHistory): C.MigrationHistory;
export function wrap(entry: C.IMenu): C.Menu;
export function wrap(entry: C.IMenuButton): C.MenuButton;
export function wrap(entry: C.IMinistry): C.Ministry;
export function wrap(entry: C.IPageMetadata): C.PageMetadata;
export function wrap(entry: C.IPage): C.Page;
export function wrap(entry: C.IRedirect): C.Redirect;
export function wrap(entry: C.IPartnerChurch): C.PartnerChurch;
export function wrap(entry: C.IResourceSet): C.ResourceSet;
export function wrap(entry: C.IResource): C.Resource;
export function wrap(entry: C.IResourceTree): C.ResourceTree;
export function wrap(entry: C.ISectionBlockText): C.SectionBlockText;
export function wrap(entry: C.ISectionCard): C.SectionCard;
export function wrap(entry: C.ISectionCodeWidget): C.SectionCodeWidget;
export function wrap(entry: C.ISectionCardDeck): C.SectionCardDeck;
export function wrap(entry: C.ISectionDomainObjectHeader): C.SectionDomainObjectHeader;
export function wrap(entry: C.ISectionEmailCapture): C.SectionEmailCapture;
export function wrap(entry: C.ISectionContactUs): C.SectionContactUs;
export function wrap(entry: C.ISectionHero): C.SectionHero;
export function wrap(entry: C.ISectionFeaturedItems): C.SectionFeaturedItems;
export function wrap(entry: C.ISectionFaq): C.SectionFaq;
export function wrap(entry: C.ISectionImageGallery): C.SectionImageGallery;
export function wrap(entry: C.ISectionIntro): C.SectionIntro;
export function wrap(entry: C.ISectionMarqueeText): C.SectionMarqueeText;
export function wrap(entry: C.ISectionHttpError): C.SectionHttpError;
export function wrap(entry: C.ISectionMinistryDetails): C.SectionMinistryDetails;
export function wrap(entry: C.ISectionLocationMap): C.SectionLocationMap;
export function wrap(entry: C.ISectionPartnerChurches): C.SectionPartnerChurches;
export function wrap(entry: C.ISectionProductList): C.SectionProductList;
export function wrap(entry: C.ISectionResourceLanding): C.SectionResourceLanding;
export function wrap(entry: C.ISectionVideoHighlight): C.SectionVideoHighlight;
export function wrap(entry: C.ISectionVideo): C.SectionVideo;
export function wrap(entry: C.ISectionTestimonials): C.SectionTestimonials;
export function wrap(entry: C.ITestimonial): C.Testimonial;
export function wrap(entry: C.ISiteConfig): C.SiteConfig;
export function wrap<CT extends keyof TypeDirectory>(entry: TypeDirectory[CT]): ClassDirectory[CT];
export function wrap(entry: IEntry<any>): IEntry<any> {
  const id = entry.sys.contentType.sys.id
  switch (id) {
    case 'cartButton':
      return new C.CartButton(entry)
    case 'card':
      return new C.Card(entry)
    case 'callToAction':
      return new C.CalltoAction(entry)
    case 'conference':
      return new C.Conference(entry)
    case 'email':
      return new C.Email(entry)
    case 'faq':
      return new C.Faq(entry)
    case 'loginButton':
      return new C.LoginButton(entry)
    case 'formField':
      return new C.FormField(entry)
    case 'migrationHistory':
      return new C.MigrationHistory(entry)
    case 'menu':
      return new C.Menu(entry)
    case 'menuButton':
      return new C.MenuButton(entry)
    case 'ministry':
      return new C.Ministry(entry)
    case 'pageMetadata':
      return new C.PageMetadata(entry)
    case 'page':
      return new C.Page(entry)
    case 'redirect':
      return new C.Redirect(entry)
    case 'partnerChurch':
      return new C.PartnerChurch(entry)
    case 'resourceSet':
      return new C.ResourceSet(entry)
    case 'resource':
      return new C.Resource(entry)
    case 'resourceTree':
      return new C.ResourceTree(entry)
    case 'section-block-text':
      return new C.SectionBlockText(entry)
    case 'section-card':
      return new C.SectionCard(entry)
    case 'section-code-widget':
      return new C.SectionCodeWidget(entry)
    case 'section-card-deck':
      return new C.SectionCardDeck(entry)
    case 'section-domain-object-header':
      return new C.SectionDomainObjectHeader(entry)
    case 'section-email-capture':
      return new C.SectionEmailCapture(entry)
    case 'section-contact-us':
      return new C.SectionContactUs(entry)
    case 'section-hero':
      return new C.SectionHero(entry)
    case 'section-featured-items':
      return new C.SectionFeaturedItems(entry)
    case 'section-faq':
      return new C.SectionFaq(entry)
    case 'section-image-gallery':
      return new C.SectionImageGallery(entry)
    case 'section-intro':
      return new C.SectionIntro(entry)
    case 'section-marquee-text':
      return new C.SectionMarqueeText(entry)
    case 'section-http-error':
      return new C.SectionHttpError(entry)
    case 'section-ministry-details':
      return new C.SectionMinistryDetails(entry)
    case 'section-location-map':
      return new C.SectionLocationMap(entry)
    case 'section-partner-churches':
      return new C.SectionPartnerChurches(entry)
    case 'section-product-list':
      return new C.SectionProductList(entry)
    case 'section-resource-landing':
      return new C.SectionResourceLanding(entry)
    case 'section-video-highlight':
      return new C.SectionVideoHighlight(entry)
    case 'section-video':
      return new C.SectionVideo(entry)
    case 'section-testimonials':
      return new C.SectionTestimonials(entry)
    case 'testimonial':
      return new C.Testimonial(entry)
    case 'site-config':
      return new C.SiteConfig(entry)
    default:
      throw new Error('Unknown content type:' + id)
  }
}
